import React from "react";
import { Line, defaults } from "react-chartjs-2";
import { CircularProgress, Typography } from "@mui/material";
import moment from "moment";
import "../../style/App.css";

defaults.global.defaultFontColor = "#3E3E3E";

class Utilization extends React.Component {
  drawGraphs() {
    if (this.props.utilizationArray !== "") {
      return (
        <div
          className="col-12"
          style={{
            height: this.props.timeframe === "CustomDateRange" ? "95%" : "100%",
          }}
        >
          <div>
            <Typography
              style={{
                display:
                  this.props.timeframe === "CustomDateRange" ? "flex" : "none",
                color: "#3E3E3E",
                justifyContent: "center",
                fontSize: "15px",
                marginTop: "10px",
              }}
            >
              {moment(new Date(this.props.start)).format("MMM DD, YYYY")} -{" "}
              {moment(new Date(this.props.end)).format("MMM DD, YYYY")}
            </Typography>
          </div>
          <Line
            data={{
              labels: this.props.victoryLabels,
              datasets: [
                {
                  label: "Utilization (%)",
                  data: this.props.victoryData,
                  borderColor: "rgb(0,150,219)",
                  backgroundColor: "transparent",
                  pointStyle: "circle",
                  pointRadius: 5,
                  pointBackgroundColor: "#ffffff",
                  pointBorderWidth: 2,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                labels: {
                  fontColor: "#3E3E3E",
                },
              },
              plugins: {
                datalabels: {
                  align: "top", // Adjust the alignment of the data labels
                  offset: 5, // Adjust the offset to move the data labels up
                  color: "transparent",
                },
              },

              scales: {
                yAxes: [
                  {
                    ticks: {
                      display: true,
                      beginAtZero: true,
                      min: 0,
                      suggestedMin: 0,
                    },
                    scaleLabel: {
                      display: true,
                      labelString: "Utilization (%)",
                      fontSize: 20,
                    },
                  },
                ],
                xAxes: [
                  {
                    scaleLabel: {
                      display: true,
                      labelString: "Timeframe",
                      fontSize: 20,
                    },
                  },
                ],
              },
            }}
          />
        </div>
      );
    } else {
      return <CircularProgress style={{ color: "#3E3E3E" }} />;
    }
  }

  render() {
    return this.drawGraphs();
  }
}
export default Utilization;
